import styled from "styled-components";

export const DrawerFormLayout = styled.form`
    min-height: 0;
    flex: 1;
`;
